<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13uAWnu/tc-custom/9781634865906.jpg?1723406276335" alt="This image is the cover for the book The Horse Who Hated Christmas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Horse Who Hated Christmas
      </h1>
      <p class="bookDescription body article font2">
        <p>Paula’s mare gets colic every Christmas, but her owner has no idea why because she has to go away over the holiday. She always comes back to a very sick horse and a huge vet bill.<br/><br/>This year Paula doesn’t have to travel. Finally, she can get to the bottom of the mystery!<br/><br/>Enlisting the help of a friend, she gets down to some serious detective work. What the two riders discover at the barn is very bizarre and not at all what they expect!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hilary Walker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65436532